import axios from "axios";

const API_URL =
  process.env.NODE_ENV === "production"
    ? `${window.location.origin}/api/payments` // Automatically detects the production host
        : process.env.REACT_APP_API_URL || `http://localhost:5000/api/payments`;

/**
 * Create a Stripe checkout session.
 * @param {string} emissionId - The emission ID.
 * @param {string} email - The user's email address.
 * @param {number} amount - The payment amount in cents.
 * @returns {Promise<string>} - The Stripe checkout session URL.
 */
export const createCheckoutSession = async (emissionId, email, amount, paidAmount) => {
  try {
    const response = await axios.post(`${API_URL}/create-checkout-session`, {
      emissionId,
      email,
      amount,
      paidAmount,
    });
    return response.data.url; // Return the session URL
  } catch (error) {
    console.error("Error creating checkout session:", error.message);
    throw new Error("Failed to create checkout session");
  }
};

/**
 * Fetch Stripe session details by session ID.
 * @param {string} sessionId - The Stripe session ID.
 * @returns {Promise<Object>} - The session details.
 */
export const fetchSessionDetails = async (sessionId) => {
  try {
    const response = await axios.get(`${API_URL}/session/${sessionId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching session details:", error.message);
    throw new Error("Failed to fetch session details");
  }
};